import React from 'react';

function AboutIntro() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
            <h1 className="h1 lg:text-4xl mb-4 text-gray-600 font-red-hat-display font-extrabold"><span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-400">Together</span>, we can map air pollution</h1>
            <p className="text-lg text-gray-600">
              We have transformed air quality monitoring, making it faster, simpler... better!
            </p>
          </div>

          <figure className="flex justify-center items-start">
            <img className="rounded shadow-2xl" src={require('../images/about-01.jpg')} width="768" height="432" alt="About us" />
          </figure>

        </div>
      </div>
    </section>
  );
}

export default AboutIntro;